// Users.js
import React, { useState } from "react";
import "./Users.css";

function Users({ departments }) {
  const [faculties, setFaculties] = useState(
    JSON.parse(localStorage.getItem("faculties")) || []
  );
  const [students, setStudents] = useState(
    JSON.parse(localStorage.getItem("students")) || []
  );

  // Faculty input states
  const [facultyName, setFacultyName] = useState("");
  const [facultyId, setFacultyId] = useState("");
  const [facultyPassword, setFacultyPassword] = useState("");

  // Student input states
  const [studentName, setStudentName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentPassword, setStudentPassword] = useState("");
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");

  // Edit states
  const [editingFaculty, setEditingFaculty] = useState(null);
  const [editingStudent, setEditingStudent] = useState(null);

  // Toggle password visibility states
  const [visibleFacultyPw, setVisibleFacultyPw] = useState({});
  const [visibleStudentPw, setVisibleStudentPw] = useState({});

  // ---------------- Faculty ----------------
  const addFaculty = () => {
    if (!facultyName || !facultyId || !facultyPassword) return;
    const newFac = { name: facultyName, id: facultyId, password: facultyPassword };
    const updated = [...faculties, newFac];
    setFaculties(updated);
    localStorage.setItem("faculties", JSON.stringify(updated));
    setFacultyName("");
    setFacultyId("");
    setFacultyPassword("");
  };

  const deleteFaculty = (id) => {
    const updated = faculties.filter((f) => f.id !== id);
    setFaculties(updated);
    localStorage.setItem("faculties", JSON.stringify(updated));
  };

  const saveEditFaculty = (id, updatedData) => {
    const updated = faculties.map((f) => (f.id === id ? { ...f, ...updatedData } : f));
    setFaculties(updated);
    localStorage.setItem("faculties", JSON.stringify(updated));
    setEditingFaculty(null);
  };

  // ---------------- Students ----------------
  const addStudent = () => {
    if (!studentName || !studentId || !studentPassword || !selectedDept || !selectedCourse) return;
    const newStu = {
      name: studentName,
      id: studentId,
      password: studentPassword,
      departmentName: selectedDept,
      course: selectedCourse,
    };
    const updated = [...students, newStu];
    setStudents(updated);
    localStorage.setItem("students", JSON.stringify(updated));
    setStudentName("");
    setStudentId("");
    setStudentPassword("");
  };

  const deleteStudent = (id) => {
    const updated = students.filter((s) => s.id !== id);
    setStudents(updated);
    localStorage.setItem("students", JSON.stringify(updated));
  };

  const saveEditStudent = (id, updatedData) => {
    const updated = students.map((s) => (s.id === id ? { ...s, ...updatedData } : s));
    setStudents(updated);
    localStorage.setItem("students", JSON.stringify(updated));
    setEditingStudent(null);
  };

  return (
    <div className="users-section">
      {/* Faculty Management */}
      <h2>👨‍🏫 Faculty Management</h2>
      <div className="form-row">
        <input placeholder="Faculty Name" value={facultyName} onChange={(e) => setFacultyName(e.target.value)} />
        <input placeholder="Faculty ID" value={facultyId} onChange={(e) => setFacultyId(e.target.value)} />
        <input type="password" placeholder="Password" value={facultyPassword} onChange={(e) => setFacultyPassword(e.target.value)} />
        <button onClick={addFaculty}>Save Faculty</button>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>ID</th>
            <th>Password</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {faculties.map((f) => (
            <tr key={f.id}>
              <td>{editingFaculty === f.id ? <input defaultValue={f.name} onChange={(e) => f.name = e.target.value} /> : f.name}</td>
              <td>{f.id}</td>
              <td>
                {editingFaculty === f.id ? (
                  <input type="password" defaultValue={f.password} onChange={(e) => f.password = e.target.value} />
                ) : (
                  <>
                    {visibleFacultyPw[f.id] ? f.password : "••••••"}
                    <button
                      className="eye-btn"
                      onClick={() =>
                        setVisibleFacultyPw((prev) => ({ ...prev, [f.id]: !prev[f.id] }))
                      }
                    >
                      {visibleFacultyPw[f.id] ? "🙈" : "👁️"}
                    </button>
                  </>
                )}
              </td>
              <td>
                {editingFaculty === f.id ? (
                  <>
                    <button onClick={() => saveEditFaculty(f.id, f)}>Save</button>
                    <button onClick={() => setEditingFaculty(null)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => setEditingFaculty(f.id)}>Edit</button>
                    <button onClick={() => deleteFaculty(f.id)}>Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Student Management */}
      <h2>🎓 Student Management</h2>
      <div className="form-row">
        <select value={selectedDept} onChange={(e) => { setSelectedDept(e.target.value); setSelectedCourse(""); }}>
          <option value="">Select Department</option>
          {departments.map((d) => <option key={d.name} value={d.name}>{d.name}</option>)}
        </select>
        {selectedDept && (
          <select value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)}>
            <option value="">Select Course</option>
            {departments.find((d) => d.name === selectedDept)?.courses.map((c) => (
              <option key={c.code} value={c.code}>{c.name} ({c.code})</option>
            ))}
          </select>
        )}
        <input placeholder="Student Name" value={studentName} onChange={(e) => setStudentName(e.target.value)} />
        <input placeholder="Student ID" value={studentId} onChange={(e) => setStudentId(e.target.value)} />
        <input type="password" placeholder="Password" value={studentPassword} onChange={(e) => setStudentPassword(e.target.value)} />
        <button onClick={addStudent}>Save Student</button>
      </div>

      {selectedDept && selectedCourse && (
        <table className="users-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>ID</th>
              <th>Password</th>
              <th>Department</th>
              <th>Course</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {students
              .filter((s) => s.departmentName === selectedDept && s.course === selectedCourse)
              .map((s) => (
                <tr key={s.id}>
                  <td>{editingStudent === s.id ? <input defaultValue={s.name} onChange={(e) => s.name = e.target.value} /> : s.name}</td>
                  <td>{s.id}</td>
                  <td>
                    {editingStudent === s.id ? (
                      <input type="password" defaultValue={s.password} onChange={(e) => s.password = e.target.value} />
                    ) : (
                      <>
                        {visibleStudentPw[s.id] ? s.password : "••••••"}
                        <button
                          className="eye-btn"
                          onClick={() =>
                            setVisibleStudentPw((prev) => ({ ...prev, [s.id]: !prev[s.id] }))
                          }
                        >
                          {visibleStudentPw[s.id] ? "🙈" : "👁️"}
                        </button>
                      </>
                    )}
                  </td>
                  <td>{s.departmentName}</td>
                  <td>{s.course}</td>
                  <td>
                    {editingStudent === s.id ? (
                      <>
                        <button onClick={() => saveEditStudent(s.id, s)}>Save</button>
                        <button onClick={() => setEditingStudent(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => setEditingStudent(s.id)}>Edit</button>
                        <button onClick={() => deleteStudent(s.id)}>Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Users;
